// extracted by mini-css-extract-plugin
module.exports = {"Picture":"picture_Picture__lHsrb"};